import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { SxProps, Theme } from "@mui/material/styles";
import { useTheme } from "@patron/utils/theme";
import { IconType } from "react-icons";
import { MaskedTextField, MaskProps } from "./MaskedTextField";

export type CustomTextFieldProps = TextFieldProps & {
  controldisabled?: boolean;
  useFullWidth?: boolean;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
  mask?: MaskProps;
};

export const CustomTextField = ({
  size = "small",
  useFullWidth = true,
  controldisabled,
  variant = "filled",
  value,
  sx,
  mask,
  ...props // Non-mask props
}: CustomTextFieldProps) => {
  const theme = useTheme();

  return mask ? (
    //@ts-ignore
    <MaskedTextField
      inputProps={{ ...props.inputProps, readOnly: controldisabled }}
      fullWidth={useFullWidth}
      disabled={controldisabled}
      value={value || ""}
      size={size}
      variant={variant}
      error={props.error}
      required={props.required}
      onAccept={props.onChange}
      {...props} // Spread non-mask props first
      {...mask} // Apply the mask prop directly
      sx={[
        {
          "&.MuiTextField-root .Mui-disabled ": {
            color: theme.appPalette.neutral[30],
            opacity: 0.9,
            pointerEvents: "unset",
            "&&:hover": {
              cursor: "default",
            },
          },
          "& .MuiInputBase-input.Mui-disabled": {
            color: theme.appPalette.neutral[30],
            WebkitTextFillColor: theme.appPalette.neutral[30],
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  ) : (
    <TextField
      fullWidth={useFullWidth}
      disabled={controldisabled}
      value={value || ""}
      size={size}
      variant={variant}
      error={props.error}
      required={props.required}
      {...props}
      sx={[
        {
          "&.MuiTextField-root .Mui-disabled ": {
            color: theme.appPalette.neutral[30],
            opacity: 0.9,
            pointerEvents: "unset",
            "&&:hover": {
              cursor: "default",
            },
          },
          "& .MuiInputBase-input.Mui-disabled": {
            color: theme.appPalette.neutral[30],
            WebkitTextFillColor: theme.appPalette.neutral[30],
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};

export default CustomTextField;
